import axios from 'axios';
import { getMimeTypeOfFile } from '../lib/getMimeTypeOfFile';
import { showNotification } from './notificationActions';

export const getDocument = (filename, key) => async (dispatch) => {
  try {
    const res = await axios({
      url: `/api/documents/file/${filename}?id=${key}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });

    const file = new Blob([res.data], { type: res.headers['content-type'] });
    const mimeType = await getMimeTypeOfFile(file);

    // JPG FILES
    if (mimeType === 'image/jpeg') {
      file.name = `${filename}`;
      const windowReference = window.open();
      const fileReader = new FileReader();

      fileReader.fileName = filename;
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        windowReference.document.write('<iframe src="' + fileReader.result + '" style="width:100%; height:100%;" allowfullscreen></iframe>');
      };
    } else {
      const fileURL = URL.createObjectURL(file);

      // TIFF FILES
      if (mimeType === 'image/tiff') {
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        // PDF FILES
        window.open(fileURL);
      }
    }
  } catch (error) {
    const isNotFound = error?.response?.status === 404;

    dispatch(
      showNotification({
        type: 'WARNING',
        message: isNotFound ? 'Datei wurde auf dem Server nicht gefunden.' : 'Die Datei konnte nicht geladen werden.',
      }),
    );

    return Promise.reject(error);
  }
};
